<div class="a-toast {{ className || EMPTY_STRING }}">
  <div class="a-toast__content {{ data?.type }}" role="alert" aria-live="polite">
    <img class="a-toast__icon" [src]="icon" alt="" />

    <div class="a-toast__content__info">
      <h4
        class="a-toast__content__info__title"
        [class.a-toast__content__info__title--no-desc]="!data?.description">
        {{ data?.title }}
      </h4>

      @if (data?.description) {
        <p
          class="a-toast__content__info__description"
          [class.a-toast__content__info__description--with-btn]="data?.button !== null"
          [innerHTML]="descriptionHtml"></p>
      }

      @if (data?.button !== null) {
        <app-button
          [titulo]="data?.button?.label || EMPTY_STRING"
          className="medium-size primary-white"
          (click)="onButtonClick($event)">
        </app-button>
      }
    </div>

    @if (data?.closeBtnIsActive) {
      <button
        type="button"
        class="a-toast__close"
        aria-label="Cerrar notificación"
        (click)="closeToast()">
        <img [src]="closeIcon" alt="" />
      </button>
    }
  </div>
</div>
